import LockIcon from "@mui/icons-material/Lock";
import { Box, Button, Container, Paper, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

import Logo from "./Logo";

const RootStyle = styled("div")(({ theme }) => ({
    display: "flex",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3),
    margin: 0,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
}));

/**
 * Component displayed when a user is authenticated but not authorized to access a route
 */
const UnauthorizedScreen = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <RootStyle>
            <Container maxWidth="sm" sx={{ padding: 0 }}>
                <Paper
                    elevation={3}
                    sx={{
                        padding: theme.spacing(5),
                        borderRadius: 2,
                        textAlign: "center",
                        boxShadow: theme.shadows[10],
                    }}
                >
                    <Box sx={{ mb: 4, display: "flex", justifyContent: "center" }}>
                        <Logo sx={{ height: 50, width: "auto" }} />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mb: 4,
                        }}
                    >
                        <LockIcon
                            sx={{
                                fontSize: 80,
                                color: "error.main",
                                padding: 2,
                                borderRadius: "50%",
                                backgroundColor: "error.lighter",
                            }}
                        />
                    </Box>

                    <Typography variant="h4" color="error" gutterBottom fontWeight="bold">
                        {t("unauthorized_title")}
                    </Typography>

                    <Typography sx={{ color: "text.secondary", mb: 3 }}>{t("unauthorized_description")}</Typography>

                    <Typography sx={{ color: "text.secondary", mb: 4 }}>{t("unauthorized_contact")}</Typography>

                    <Button
                        to="/"
                        component={RouterLink}
                        variant="contained"
                        size="large"
                        sx={{
                            mt: 2,
                            px: 4,
                            py: 1.5,
                            fontWeight: "bold",
                            borderRadius: 2,
                            fontSize: "1rem",
                            "&:hover": {
                                color: "white",
                            },
                        }}
                    >
                        {t("go_to_home")}
                    </Button>
                </Paper>
            </Container>
        </RootStyle>
    );
};

export default UnauthorizedScreen;
